import { Button, Card, Typography, Progress } from "antd"
import { ScheduledEvent } from "../scheduleApi"
import { useGetJobItemsQuery, useGetJobQuery } from "../scheduleQueries"
import { formatDuration, getJobEstimatedDuration, getJobTotalActualDuration, getRemainingHoursData, handleViewJobDetails } from "./jobOverviewModel"
import React from 'react'

const { Text } = Typography

type Props = {
  event: ScheduledEvent
}

const JobDrawerJobOverview = ({ event }: Props) => {
  const { data: job } = useGetJobQuery(event.jobId)
  const { data: jobItems } = useGetJobItemsQuery(event.jobId)

  const estimatedDuration = getJobEstimatedDuration(job?.workareas ?? [], jobItems)
  const completedDuration = getJobTotalActualDuration(job?.workareas ?? [], jobItems?.actualItems ?? [])
  const { jobCompletionPercentage, remainingSeconds } = getRemainingHoursData(completedDuration, estimatedDuration)

  const getTagAccentColors = (percentage: number): React.CSSProperties => {
    if (percentage < 0) {
      return {
        backgroundColor: '#fff1f0',
        borderColor: '#cf1322',
        color: '#cf1322',
      }
    }
    if (percentage <= 25) {
      return {
        backgroundColor: '#fffbe6',
        borderColor: '#ffc53d',
        color: '#ffc53d',
      }
    }
    return {
      backgroundColor: '#f6ffed',
      borderColor: '#73d13d',
      color: '#73d13d',
    }
  }

  return <div style={{ marginBottom: '24px' }}>
    <div style={{ marginBottom: '24px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <Text style={{ fontSize: '14px' }}>
          Job Overview
        </Text>
        <span>
          <Button onClick={() => handleViewJobDetails(event)}>
            View Job Details
          </Button>
        </span>
      </div>
    </div>

    <Card style={{ backgroundColor: 'white', border: '1px solid #e8e8e8' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <Text style={{ fontSize: '14px', color: '#666' }}>Hours Remaining</Text>
        <div
          style={{ border: '1px solid', borderRadius: '100px', padding: '4px 8px', ...getTagAccentColors(jobCompletionPercentage) }}
        >
          {Math.floor(jobCompletionPercentage)}%
        </div>
      </div>
      <div>
        <Text style={{ fontSize: '16px', fontWeight: '600' }}>
          {formatDuration({ seconds: Math.abs(remainingSeconds) })} {remainingSeconds < 0 && "over"}
        </Text>
      </div>

      <div style={{ width: '100%', marginBottom: '12px' }}>
        <Progress
          percent={estimatedDuration.seconds === 0 || completedDuration.seconds > estimatedDuration.seconds ? 100 : Math.round(jobCompletionPercentage)}
          showInfo={false}
          strokeColor="#52c41a"
          trailColor="#f0f0f0"
          size={["", 24]}
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={{ fontSize: '14px', color: '#666' }}>Total Hours</Text>
        <Text style={{ fontSize: '14px', fontWeight: '600' }}>
          {formatDuration(estimatedDuration)}
        </Text>
      </div>
    </Card>
  </div>
}

export default JobDrawerJobOverview